import { crane } from '../beasts';
import { cloud } from '../motifs';
import { INK, M } from '../palette';
import { registerPlate } from '../registry';

const CREAM = ['#fbf6ec', '#e6dccb', '#b8a890'] as const;

/** 07 ผู้สืบทอด: the heir's plate, black lacquer with cream clouds, a crane rising off the right end. */
registerPlate({
  id: 'heir',
  name: 'ผู้สืบทอด',
  ground: INK,
  trim: M.goldLo,
  text: { fill: [M.goldHi, M.gold], line: '#0c0808' },
  inset: [14, 14],
  front(p, f) {
    cloud(p, f.x - 11, f.b + 5, 24, CREAM);
    cloud(p, f.x - 5, f.y + 8, 15, CREAM);
    crane(p, f.r - 1, f.y + 1, 1.2, false);
  },
  motion: {
    sprites: { wisp: { w: 12, h: 8, draw: (p) => cloud(p, 0, 8, 12, CREAM) } },
    play(a, t, f) {
      a.spr('wisp', f.x + 8 + Math.sin(t * 0.6) * 3, f.y - 7);
    },
  },
});
